export const CHANGE_DATE = 'CHANGE_DATE';
export const GET_SHIFTS_START = 'GET_SHIFTS_START';
export const GET_SHIFTS_SUCCESS = 'GET_SHIFTS_SUCCESS';
export const GET_SHIFTS_FAIL = 'GET_SHIFTS_FAIL';
export const GET_RESTAURANT_START = 'GET_RESTAURANT_START';
export const GET_RESTAURANT_SUCCESS = 'GET_RESTAURANT_SUCCESS';
export const GET_RESTAURANT_FAIL = 'GET_RESTAURANT_FAIL';
export const GET_ALLEMPLOYEES_START = 'GET_ALLEMPLOYEES_START';
export const GET_ALLEMPLOYEES_SUCCESS = 'GET_ALLEMPLOYEES_SUCCESS';
export const GET_ALLEMPLOYEES_FAIL = 'GET_ALLEMPLOYEES_FAIL';
export const CREATE_SHIFT_START = 'CREATE_SHIFT_START';
export const CREATE_SHIFT_SUCCESS = 'CREATE_SHIFT_SUCCESS';
export const CREATE_SHIFT_FAIL = 'CREATE_SHIFT_FAIL';
export const UPDATE_SHIFT_START = 'UPDATE_SHIFT_START';
export const UPDATE_SHIFT_SUCCESS = 'UPDATE_SHIFT_SUCCESS';
export const UPDATE_SHIFT_FAIL = 'UPDATE_SHIFT_FAIL';
export const DELETE_SHIFT_START = 'DELETE_SHIFT_START';
export const DELETE_SHIFT_SUCCESS = 'DELETE_SHIFT_SUCCESS';
export const DELETE_SHIFT_FAIL = 'DELETE_SHIFT_FAIL';
export const DELETE_SHIFTS_START = 'DELETE_SHIFTS_START';
export const DELETE_SHIFTS_SUCCESS = 'DELETE_SHIFTS_SUCCESS';
export const DELETE_SHIFTS_FAIL = 'DELETE_SHIFTS_FAIL';
export const ADD_SHIFT = 'ADD_SHIFT';
export const COPY_SHIFT = 'COPY_SHIFT';
export const UPDATE_ISLUNCH = 'UPDATE_ISLUNCH';
export const UPDATE_EMPLOYEEID = 'UPDATE_EMPLOYEEID';
export const UPDATE_TITLE = 'UPDATE_TITLE';
export const UPDATE_NETSALES = 'UPDATE_NETSALES';
export const UPDATE_BEER = 'UPDATE_BEER';
export const UPDATE_BYBOTTLE = 'UPDATE_BYBOTTLE';
export const UPDATE_FOOD = 'UPDATE_FOOD';
export const UPDATE_LIQUOR = 'UPDATE_LIQUOR';
export const UPDATE_MIXEDCOCKTAILS = 'UPDATE_MIXEDCOCKTAILS';
export const UPDATE_NABEVERAGE = 'UPDATE_NABEVERAGE';
export const UPDATE_SAKE = 'UPDATE_SAKE';
export const UPDATE_SUSHI = 'UPDATE_SUSHI';
export const UPDATE_WINE = 'UPDATE_WINE';
export const UPDATE_BARRATIO = 'UPDATE_BARRATIO';
export const UPDATE_CCTIP = 'UPDATE_CCTIP';
export const UPDATE_SUSHITIP = 'UPDATE_SUSHITIP';
export const UPDATE_BARTIP = 'UPDATE_BARTIP';
export const UPDATE_EXPOTIP = 'UPDATE_EXPOTIP';
export const UPDATE_EXPORATIO = 'UPDATE_EXPORATIO';
export const UPDATE_HOSTRATIO = 'UPDATE_HOSTRATIO';
export const UPDATE_HOSTTIP = 'UPDATE_HOSTTIP';
export const UPDATE_SERVERRATIO = 'UPDATE_SERVERRATIO';
export const UPDATE_BUSSERTIP = 'UPDATE_BUSSERTIP';
export const UPDATE_BUSSERRATIO = 'UPDATE_BUSSERRATIO';
export const UPDATE_FINALTIPOUT = 'UPDATE_FINALTIPOUT';
export const UPDATE_SUSHIPERCENTAGE = 'UPDATE_SUSHIPERCENTAGE';
export const UPDATE_BARPERCENTAGE = 'UPDATE_BARPERCENTAGE';
export const UPDATE_HOSTPERCENTAGE = 'UPDATE_HOSTPERCENTAGE';
export const UPDATE_EXPOPERCENTAGE = 'UPDATE_EXPOPERCENTAGE';
export const UPDATE_BUSSERPERCENTAGE = 'UPDATE_BUSSERPERCENTAGE';
export const UPDATE_LUNCHEXPOPERCENTAGE = 'UPDATE_LUNCHEXPOPERCENTAGE';
export const CALCULATE_SHIFT_TIPS = 'CALCULATE_SHIFT_TIPS';
export const SPLIT_LUNCH_SERVER_TIPS = 'SPLIT_LUNCH_SERVER_TIPS';
export const SPLIT_DINNER_SERVER_TIPS = 'SPLIT_DINNER_SERVER_TIPS';
export const VALIDATE_LUNCH_TIPS = 'VALIDATE_LUNCH_TIPS';
export const VALIDATE_DINNER_TIPS = 'VALIDATE_DINNER_TIPS';
// export const CALCULATE_LUNCH_HOST_SHIFT_TIPS = "CALCULATE_LUNCH_HOST_SHIFT_TIPS"
export const UPDATE_HOSTFACTOR = 'UPDATE_HOSTFACTOR';
export const UPDATE_EXPOFACTOR = 'UPDATE_EXPOFACTOR';
export const UPDATE_BUSSERFACTOR = 'UPDATE_BUSSERFACTOR';
export const UPDATE_NOTES = 'UPDATE_NOTES';

export const UPDATE_REPORT_RESTAURANT_ID = 'UPDATE_REPORT_RESTAURANT_ID';
export const UPDATE_REPORT_BEGIN_DATE = 'UPDATE_REPORT_BEGIN_DATE';
export const UPDATE_REPORT_END_DATE = 'UPDATE_REPORT_END_DATE';
export const UPDATE_REPORT_EMPLOYEE_ID = 'UPDATE_REPORT_EMPLOYEE_ID';
export const GET_REPORT_SUSHI_TIPOUT_SUCCESS =
  'GET_REPORT_SUSHI_TIPOUT_SUCCESS';
export const GET_REPORT_SUSHI_TIPOUT_START = 'GET_REPORT_SUSHI_TIPOUT_START';
export const GET_REPORT_SUSHI_TIPOUT_FAIL = 'GET_REPORT_SUSHI_TIPOUT_FAIL';
export const GET_REPORT_EMPLOYEE_TIPOUT_SUCCESS =
  'GET_REPORT_EMPLOYEE_TIPOUT_SUCCESS';
export const GET_REPORT_EMPLOYEE_TIPOUT_START =
  'GET_REPORT_EMPLOYEE_TIPOUT_START';
export const GET_REPORT_EMPLOYEE_TIPOUT_FAIL =
  'GET_REPORT_EMPLOYEE_TIPOUT_FAIL';
export const GET_REPORT_EMPLOYEE_SHIFTS_SUCCESS =
  'GET_REPORT_EMPLOYEE_SHIFTS_SUCCESS';
export const GET_REPORT_EMPLOYEE_SHIFTS_START =
  'GET_REPORT_EMPLOYEE_SHIFTS_START';
export const GET_REPORT_EMPLOYEE_SHIFTS_FAIL =
  'GET_REPORT_EMPLOYEE_SHIFTS_FAIL';

export const ADD_EMPLOYEE_START = 'ADD_EMPLOYEE_START';
export const ADD_EMPLOYEE_SUCCESS = 'ADD_EMPLOYEE_SUCCESS';
export const ADD_EMPLOYEE_FAIL = 'ADD_EMPLOYEE_FAIL';
export const UPDATE_EMPLOYEE_START = 'UPDATE_EMPLOYEE_START';
export const UPDATE_EMPLOYEE_SUCCESS = 'UPDATE_EMPLOYEE_SUCCESS';
export const UPDATE_EMPLOYEE_FAIL = 'UPDATE_EMPLOYEE_FAIL';
export const DELETE_EMPLOYEE_START = 'DELETE_EMPLOYEE_START';
export const DELETE_EMPLOYEE_SUCCESS = 'DELETE_EMPLOYEE_SUCCESS';
export const DELETE_EMPLOYEE_FAIL = 'DELETE_EMPLOYEE_FAIL';

export const LOGIN_SUCCESSFUL = 'LOGIN_SUCCESSFUL';
export const GET_USER_START = 'GET_USER_START';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAIL = 'GET_USER_FAIL';

export const UPDATE_MYSHIFTS_BEGIN_DATE = 'UPDATE_MYSHIFTS_BEGIN_DATE';
export const UPDATE_MYSHIFTS_END_DATE = 'UPDATE_MYSHIFTS_END_DATE';

export const GET_MYSHIFTS_START = 'GET_MYSHIFTS_START';
export const GET_MYSHIFTS_SUCCESS = 'GET_MYSHIFTS_SUCCESS';
export const GET_MYSHIFTS_FAIL = 'GET_MYSHIFTS_FAIL';
